import * as React from "react";
import { cn } from "@/lib/utils";

interface ReceiptDividerProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "solid" | "dashed" | "dotted";
}

const ReceiptDivider = React.forwardRef<HTMLDivElement, ReceiptDividerProps>(
  ({ className, variant = "solid", ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "my-4 font-mono text-muted-foreground/30 text-xs tracking-[0.3em] select-none",
          className
        )}
        {...props}
      >
        {variant === "solid" && "────────────────────────────────"}
        {variant === "dashed" && "─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─"}
        {variant === "dotted" && "· · · · · · · · · · · · · · · · · ·"}
      </div>
    );
  }
);
ReceiptDivider.displayName = "ReceiptDivider";

export { ReceiptDivider };
